import React, { useEffect, useState } from "react";
import Card from "components/card";
import ButtonEdit from "../../../../assets/img/icons/ButtonEdit.svg";
import DeleteIcon from "../../../../assets/img/icons/deleteIcon.svg";
import ViewIcon from "../../../../assets/img/icons/ViewIcon.svg";
import {
  createColumnHelper,
  flexRender,
  getCoreRowModel,
  getSortedRowModel,
  SortingState,
  useReactTable,
} from "@tanstack/react-table";
import {
  Box,
  Button,
  ChakraProvider,
  Collapse,
  HStack,
  Input,
  Spinner,
  VStack,
} from "@chakra-ui/react";
import Select from "react-select";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { resetFields, setText, updateField } from "redux/reducers/searchSlice";
import {
  downloadPdfApi,
  getSuggestion,
  getSuggestionForName,
} from "services/customAPI";
import * as XLSX from "xlsx";
import { actions } from "react-table";
import { Checkbox } from "@chakra-ui/react";

const customStyles = {
  control: (base: any, state: any) => ({
    ...base,
    borderRadius: "5px",
    borderWidth: "2px",
    width: "300px",
    padding: "0px 0px",
    marginTop: "1px",
    borderColor: state.isFocused ? "teal.500" : "gray.600",
    backgroundColor: "transparent",
    "&:hover": {
      borderColor: state.isFocused ? "teal.500" : "gray.600",
    },
  }),
  option: (provided: any, state: any) => ({
    ...provided,
    backgroundColor: state.isSelected ? "teal.500" : "white",
    color: state.isSelected ? "black" : "black",
  }),
};
//?autofill

type RowObj = {
  name: string;
  designation: string;
  project: string;
  department: string;
  mobileNumber: string;
  action: customFieldType2;
};

type customFieldType2 = {
  id: string;
};

const columnHelper = createColumnHelper<RowObj>();

function ColumnsTableContacts(props: {
  allContacts: any;
  tableData: any;
  handleClickForDeleteModal: (data: any) => void;
  handleClickForDeleteModalMany: (data: any) => void;
  setSearchText: any;
  handleNavBar: any;
  setCurrentPage: any;
  deleteMultiple: any;
  setDeleteMultiple: any;
  setDeleteMultipleDisp: any;
}) {
  const dispatch = useDispatch();
  const searchObject = useSelector((state: any) => state?.search);
  const handleChange = (field: any, value: any) => {
    dispatch(updateField({ field, value }));
  };
  const handleReset = () => {
    dispatch(resetFields());
  };

  const { tableData, handleClickForDeleteModal } = props;
  const [sorting, setSorting] = React.useState<SortingState>([]);
  const navigate = useNavigate(); // Create a history object
  const handleEditClick = (contactId: string) => {
    // navigate(`../contacts/contactform/${contactId}`);
  };
  const user = useSelector((store: any) => store.auth.user);
  const project = useSelector((store: any) => store.auth.project);
  const [userProject, setUserProject] = useState("");
  // const [deleteMultiple, setDeleteMultiple] = useState<any>([]);
  // useEffect(() => {
  //   console.log({ Del: props.deleteMultiple });
  // }, [props.deleteMultiple]);

  //console.log({user});
  const oldColumns = [
    columnHelper.accessor("name", {
      id: " name",
      header: () => (
        <p className="text-sm font-bold text-gray-600 dark:text-white">Name</p>
      ),
      cell: (info: any) => (
        <div className="flex items-center" style={{}}>
          {/* {info.row.original} */}
          {user != "user" && (
            <Checkbox
              onChange={(e) => {
                if (e.target.checked) {
                  props.setDeleteMultiple((prev: any) => [
                    ...prev,
                    info.row.original.action.id,
                  ]);
                  props.setDeleteMultipleDisp((prev: any) => [
                    ...prev,
                    info.row.original.name,
                  ]);
                } else {
                  props.setDeleteMultiple((prev: any) =>
                    prev.filter(
                      (num: any) => num !== info.row.original.action.id
                    )
                  );
                  props.setDeleteMultipleDisp((prev: any) =>
                    prev.filter((num: any) => num !== info.row.original.name)
                  );
                }
              }}
              isChecked={props.deleteMultiple.includes(
                info.row.original.action.id
              )}
              size="lg"
              colorScheme="black"
              className={`mr-3 h-6 w-6 min-w-6 rounded border-2 ${
                props.deleteMultiple.includes(info.row.original.action.id)
                  ? "border-green-500"
                  : "border-mediumseagreen"
              }`}
            />
          )}
          <p className="text-sm font-bold text-navy-700 dark:text-white">
            {info.getValue().charAt(0).toUpperCase() + info.getValue().slice(1)}
          </p>
        </div>
      ),
    }),
    columnHelper.accessor("designation", {
      id: "designation",
      header: () => (
        <p className="text-sm font-bold text-gray-600 dark:text-white">
          Designation
        </p>
      ),
      cell: (info) => (
        <p className="text-sm font-bold text-navy-700 dark:text-white">
          {info.getValue().charAt(0).toUpperCase() + info.getValue().slice(1)}
        </p>
      ),
    }),
    columnHelper.accessor("project", {
      id: "project",
      header: () => (
        <p className="text-sm font-bold text-gray-600 dark:text-white">
          Project
        </p>
      ),
      cell: (info) => (
        <p className="text-sm font-bold text-navy-700 dark:text-white">
          {info.getValue().charAt(0).toUpperCase() + info.getValue().slice(1)}
        </p>
      ),
    }),
    columnHelper.accessor("department", {
      id: "department",
      header: () => (
        <p className="text-sm font-bold text-gray-600 dark:text-white">
          Department
        </p>
      ),
      cell: (info) => (
        <p className="text-sm font-bold text-navy-700 dark:text-white">
          {info.getValue().charAt(0).toUpperCase() + info.getValue().slice(1)}
        </p>
      ),
    }),
    columnHelper.accessor("mobileNumber", {
      id: "mobileNumber",
      header: () => (
        <p className="text-sm font-bold text-gray-600 dark:text-white">
          Mobile No.
        </p>
      ),
      cell: (info) => (
        <p className="text-sm font-bold text-navy-700 dark:text-white">
          {info.getValue()}
        </p>
      ),
    }),
    columnHelper.accessor("action", {
      id: "action",
      header: () => (
        <p className="text-sm font-bold text-gray-600 dark:text-white">
          Action
        </p>
      ),
      cell: (info) => (
        // <p className="text-sm font-bold text-navy-700 dark:text-white">
        //   <img src={eyeview} height={30} width={30} />
        // </p>
        <div className="flex items-center">
          {user != "user" ? (
            <div className="flex items-center justify-evenly">
              <img
                src={ButtonEdit}
                className="button-edit me-2 cursor-pointer"
                onClick={() => {
                  console.log({ project }, info.getValue(), { userProject });

                  navigate(
                    `/admin/contacts/contactForm/${info.getValue()?.id}`
                  );
                }}
                height={30}
                width={30}
              />
              <img
                src={DeleteIcon}
                className="button-delete cursor-pointer"
                onClick={() => handleClickForDeleteModal(info.row.original)}
                height={30}
                width={30}
              />
            </div>
          ) : (
            <img
              src={ViewIcon}
              className="button-edit me-2 cursor-pointer"
              // onClick={() => handleEditClick(info.row.original.action.id)}
              onClick={() => {
                navigate(`/admin/contacts/contactForm/${info.getValue()?.id}`);
              }}
              height={30}
              width={30}
            />
          )}
        </div>
      ),
    }),
  ];
  const columns = oldColumns;
  // user == "user" ? oldColumns.filter((e) => e.id != "action") : oldColumns;
  const [suggestionDepartment, setSuggestionDepartment] = useState([]);
  const [suggestionDesignation, setSuggestionDesignation] = useState([]);
  const [suggestionProject, setSuggestionProject] = useState([]);
  const [suggestionName, setSuggestionName] = useState([]);

  const loadData = async () => {
    const data: any = await getSuggestion();
    const { designations, departments, projects } = data;
    if (departments?.length > 0) {
      const opt = departments.map((e: any) => {
        return { value: e, label: e };
      });
      setSuggestionDepartment(opt);
    }

    if (designations?.length > 0) {
      const opt = designations.map((e: any) => {
        return { value: e, label: e };
      });
      setSuggestionDesignation(opt);
    }
    if (projects?.length > 0) {
      const opt = projects.map((e: any) => {
        return { value: e, label: e };
      });
      setSuggestionProject(opt);
    }
  };

  const loadSuggestionForName = async (txt: string) => {
    const data: any = txt && (await getSuggestionForName(txt));
    if (data?.length > 0) {
      const opt = data.map((e: any) => {
        return { value: e, label: e };
      });
      setSuggestionName(opt);
    }
  };

  useEffect(() => {
    //?data
    loadData();
  }, []);
  const [data, setData] = React.useState([...tableData]);
  const table = useReactTable({
    data,
    columns,
    state: {
      sorting,
    },
    onSortingChange: setSorting,
    getCoreRowModel: getCoreRowModel(),
    getSortedRowModel: getSortedRowModel(),
    debugTable: true,
  });
  useEffect(() => {
    setData([...tableData]);
  }, [tableData]);
  const contactForm = () => {
    navigate("../contacts/contactForm");
  };
  const [isOpen, setIsOpen] = useState(false);
  const handleToggle = () => {
    setIsOpen(!isOpen);
  };
  const [isLoading, setIsLoading] = useState(false);

  const exportToXLSX = (data: any) => {
    setIsLoading(true);
    const cleanedData = data.map((item: any) => {
      const { __v, _id, createdAt, updatedAt, ...cleanedItem } = item;
      return cleanedItem;
    });
    const ws = XLSX.utils.json_to_sheet(cleanedData);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Sheet1");
    XLSX.writeFile(wb, "Contact Data.xlsx");
  };

  return (
    <>
      {isLoading ? (
        <>
          <div className="z-10 flex min-h-screen items-center justify-center">
            <ChakraProvider>
              <Spinner
                thickness="4px"
                speed="0.999s"
                emptyColor="gray.200"
                color="green.500"
                size="xl"
              />
            </ChakraProvider>
          </div>
        </>
      ) : (
        <>
          <Card extra={"w-full p-4 h-full"}>
            <header className="relative flex items-center justify-between">
              <div className="text-xl font-bold text-navy-700 dark:text-white">
                Contacts
              </div>
              <div>
                {!isOpen && (
                  <Button
                    type="submit"
                    className="mx-5 rounded-md bg-indigo-700 p-2 text-white dark:bg-brand-400"
                    onClick={() => {
                      // dispatch(resetFields());
                      handleToggle();
                      // props.setSearchText("");
                      props.handleNavBar();
                      props.setCurrentPage();
                    }}
                  >
                    Filter Search
                  </Button>
                )}
                <Button
                  type="submit"
                  className="rounded-md bg-blue-700 p-2 text-white dark:bg-brand-400"
                  onClick={async () => {
                    const filter = { ...searchObject };
                    try {
                      setIsLoading(true);
                      const res = await downloadPdfApi({ filter });
                      exportToXLSX(res);
                    } catch (error) {
                      console.log("xlsx generate error");
                    } finally {
                      setIsLoading(false);
                    }
                  }}
                >
                  Download List
                </Button>
                {user != "user" && (
                  <Button
                    type="submit"
                    className=" mx-5 rounded-md bg-green-700 p-2 text-white dark:bg-brand-400"
                    onClick={contactForm}
                  >
                    Add Contact
                  </Button>
                )}
                {props.deleteMultiple.length > 0 && (
                  <>
                    {" "}
                    <Button
                      type="submit"
                      className=" mx-5 rounded-md bg-red-700 p-2 text-white dark:bg-brand-400"
                      // onClick={handleClickForDeleteModalMany("")}
                      onClick={() =>
                        handleClickForDeleteModal(props.deleteMultiple)
                      }
                    >
                      Delete Selected
                    </Button>
                    <Button
                      type="submit"
                      className=" mx-5  ml-[-2px] rounded-md bg-brandLinear p-2 text-white dark:bg-brand-400"
                      // onClick={handleClickForDeleteModalMany("")}
                      onClick={() => props.setDeleteMultiple([])}
                    >
                      Uncheck All
                    </Button>
                  </>
                )}
              </div>
            </header>
            {/*//* Search filter form */}
            <div
              className="mt-2  overflow-x-scroll xl:overflow-x-hidden"
              onKeyDown={(e) => {
                if (e.key === "Enter") {
                  handleToggle();
                  props.allContacts();
                  props.handleNavBar();
                }
              }}
            >
              {/* //? search form for contact */}
              <ChakraProvider>
                <Box>
                  <Collapse in={isOpen} animateOpacity>
                    <VStack spacing={4}>
                      <HStack spacing={4}>
                        {/* <Input
                          style={{
                            borderWidth: "2px",
                            width: "300px",
                            borderColor: "gray.600",
                          }}
                          focusBorderColor="teal.500"
                          p={2}
                          placeholder="Name"
                          value={searchObject?.name}
                          onChange={(e) => handleChange("name", e.target.value)}
                        /> */}

                        <Select
                          isClearable
                          options={suggestionName}
                          defaultValue={
                            searchObject?.name && {
                              value: searchObject?.name,
                              label: searchObject?.name,
                            }
                          }
                          onInputChange={(e) => {
                            loadSuggestionForName(e);
                          }}
                          menuPortalTarget={document.body}
                          placeholder="Name"
                          onChange={(e: any) => {
                            handleChange("name", e?.value);
                          }}
                          classNamePrefix="custom-select"
                          styles={customStyles}
                        />

                        {/* <Input
                          style={{
                            borderWidth: "2px",
                            width: "300px",
                            borderColor: "gray.600",
                          }}
                          focusBorderColor="teal.500"
                          p={2}
                          placeholder="Designation"
                          value={searchObject?.designation}
                          onChange={(e) =>
                            handleChange("designation", e.target.value)
                          }
                        /> */}
                        <Select
                          isClearable
                          options={suggestionDesignation}
                          defaultValue={
                            searchObject?.designation && {
                              value: searchObject?.designation,
                              label: searchObject?.designation,
                            }
                          }
                          menuPortalTarget={document.body}
                          placeholder="Designation"
                          onChange={(e: any) => {
                            handleChange("designation", e?.value);
                          }}
                          classNamePrefix="custom-select"
                          styles={customStyles}
                        />
                        {/* <Input
                          style={{
                            borderWidth: "2px",
                            width: "300px",
                            borderColor: "gray.600",
                          }}
                          focusBorderColor="teal.500"
                          p={2}
                          placeholder="Project"
                          value={searchObject?.project}
                          onChange={(e) =>
                            handleChange("project", e.target.value)
                          }

                        /> */}
                        <Select
                          isClearable
                          options={suggestionProject}
                          defaultValue={
                            searchObject?.project && {
                              value: searchObject?.project,
                              label: searchObject?.project,
                            }
                          }
                          // value={values.department}
                          // inputValue={values.department}
                          // onInputChange={(e) => handleChange(e)}
                          menuPortalTarget={document.body}
                          placeholder="Project"
                          onChange={(e) => {
                            handleChange("project", e?.value);
                          }}
                          // className="custom-select-control mt-2 h-12 w-full rounded-xl border border-gray-400 bg-white/0 p-3 text-sm font-bold outline-none dark:text-white"
                          classNamePrefix="custom-select"
                          styles={customStyles}
                        />
                      </HStack>
                      <HStack spacing={4}>
                        {/* <Input
                          style={{
                            borderWidth: "2px",
                            width: "300px",
                            borderColor: "gray.600",
                          }}
                          focusBorderColor="teal.500"
                          p={2}
                          placeholder="Department"
                          value={searchObject?.department}
                          onChange={(e) =>
                            handleChange("department", e.target.value)
                          }
                        /> */}
                        <Select
                          isClearable
                          options={suggestionDepartment}
                          defaultValue={
                            searchObject?.department && {
                              value: searchObject?.department,
                              label: searchObject?.department,
                            }
                          }
                          // value={values.department}
                          // inputValue={values.department}
                          // onInputChange={(e) => handleChange(e)}
                          menuPortalTarget={document.body}
                          placeholder="Department"
                          onChange={(e) => {
                            handleChange("department", e?.value);
                          }}
                          // className="custom-select-control mt-2 h-12 w-full rounded-xl border border-gray-400 bg-white/0 p-3 text-sm font-bold outline-none dark:text-white"
                          classNamePrefix="custom-select"
                          styles={customStyles}
                        />
                        <Input
                          style={{
                            borderWidth: "2px",
                            width: "300px",
                            borderColor: "gray.600",
                          }}
                          focusBorderColor="teal.500"
                          p={2}
                          placeholder="Mobile Number"
                          value={searchObject?.mobileNumber}
                          onChange={(e) =>
                            handleChange("mobileNumber", e.target.value)
                          }
                        />
                        <Input
                          style={{
                            borderWidth: "2px",
                            width: "300px",
                            borderColor: "gray.600",
                          }}
                          focusBorderColor="teal.500"
                          p={2}
                          placeholder="NCL Number Office"
                          value={searchObject?.nclNumberOffice}
                          onChange={(e) =>
                            handleChange("nclNumberOffice", e.target.value)
                          }
                        />
                      </HStack>
                      <HStack spacing={4}>
                        <Input
                          style={{
                            borderWidth: "2px",
                            width: "300px",
                            borderColor: "gray.600",
                          }}
                          focusBorderColor="teal.500"
                          p={2}
                          placeholder="NCL Number Residence"
                          value={searchObject?.nclNumberResidence}
                          onChange={(e) =>
                            handleChange("nclNumberResidence", e.target.value)
                          }
                        />
                        <Input
                          style={{
                            borderWidth: "2px",
                            width: "300px",
                            borderColor: "gray.600",
                          }}
                          focusBorderColor="teal.500"
                          p={2}
                          placeholder="Landline Number Office"
                          value={searchObject?.landlineNumberOffice}
                          onChange={(e) =>
                            handleChange("landlineNumberOffice", e.target.value)
                          }
                        />
                        <Input
                          style={{
                            borderWidth: "2px",
                            width: "300px",
                            borderColor: "gray.600",
                          }}
                          focusBorderColor="teal.500"
                          p={2}
                          placeholder="Landline Number Residence"
                          value={searchObject?.landlineNumberResidence}
                          onChange={(e) =>
                            handleChange(
                              "landlineNumberResidence",
                              e.target.value
                            )
                          }
                        />
                      </HStack>
                      <HStack className="my-1" spacing={4}>
                        <Button
                          type="submit"
                          colorScheme="green"
                          onClick={() => {
                            props.allContacts();
                            props.handleNavBar();
                          }}
                        >
                          Search
                        </Button>
                        <Button
                          type="submit"
                          colorScheme="red"
                          onClick={() => {
                            handleToggle();
                            // dispatch(resetFields());
                            props.handleNavBar();
                          }}
                        >
                          Cancel
                        </Button>
                        {/* <Button
                          style={{ background: "gold", color: "white" }}
                          type="submit"
                          // colorScheme="red"
                          onClick={() => {
                            dispatch(resetFields());
                            // dispatch(resetFields());
                            // props.handleNavBar();
                          }}
                        >
                          Clear
                        </Button> */}
                      </HStack>
                    </VStack>
                  </Collapse>
                </Box>
              </ChakraProvider>
            </div>
            {/* //*Table of contacts */}
            <div className="overflow-x-scroll xl:overflow-x-hidden">
              <table className="w-full">
                <thead>
                  {table.getHeaderGroups().map((headerGroup) => (
                    <tr
                      key={headerGroup.id}
                      className="!border-px !border-gray-400"
                    >
                      {headerGroup.headers.map((header) => {
                        return (
                          <th
                            key={header.id}
                            colSpan={header.colSpan}
                            onClick={header.column.getToggleSortingHandler()}
                            className="cursor-pointer border-b-[1px] border-gray-200 pb-2 pr-4 pt-4 text-start"
                          >
                            <div className="items-center justify-between text-xs text-gray-200">
                              {flexRender(
                                header.column.columnDef.header,
                                header.getContext()
                              )}
                              {{
                                asc: "",
                                desc: "",
                              }[header.column.getIsSorted() as string] ?? null}
                            </div>
                          </th>
                        );
                      })}
                    </tr>
                  ))}
                </thead>
                {tableData.length == 0 ? (
                  <tbody>
                    <tr>
                      <td
                        colSpan={columns.length}
                        style={{ textAlign: "center" }}
                      >
                        <h2 className="m-4" style={{ fontSize: "30px" }}>
                          No Results!
                        </h2>
                      </td>
                    </tr>
                  </tbody>
                ) : (
                  <tbody>
                    {table
                      .getRowModel()
                      .rows.slice(0, 10)
                      .map((row) => {
                        // console.log("object row :>> ", row);
                        return (
                          <tr key={row.id}>
                            {row.getVisibleCells().map((cell) => {
                              return (
                                <td
                                  key={cell.id}
                                  className="min-w-[20%] border-white/0 py-3 pr-4 text-start"
                                >
                                  {flexRender(
                                    cell.column.columnDef.cell,
                                    cell.getContext()
                                  )}
                                </td>
                              );
                            })}
                          </tr>
                        );
                      })}
                  </tbody>
                )}
              </table>
            </div>
          </Card>
        </>
      )}
    </>
  );
}
export default ColumnsTableContacts;
